<template>

  <div class="p-3">
    <creating
      v-if="creating"
      height="100%" />
    <div
      v-if="!creating"
      class="pb-3"
      style="max-width: 520px">
      <div class="form-group">
        <label>Razão social da empresa *</label>
        <input
          type="text"
          class="form-control"
          v-model="customer.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
      <div class="form-group">
        <label>CNPJ *</label>
        <input
          type="text"
          class="form-control"
          v-model="customer.register_number"
          placeholder="00.000.000/0000-00">
        <ValidateMessage :error="validateErrors.register_number" />
      </div>
      <div class="form-group">
        <label>Endereço de e-mail do financeiro *</label>
        <input
          type="text"
          class="form-control"
          v-model="customer.email">
        <ValidateMessage :error="validateErrors.email" />
      </div>
      <div class="form-group">
        <label>Telefone de contato do financeiro (prefixo + número) *</label>
        <div class="row">
          <div class="col-3">
            <input
              type="text"
              class="form-control"
              v-model="customer.phone_prefix"
              placeholder="DDD"
              maxlength="2">
          </div>
          <div class="col-9">
            <input
              type="text"
              class="form-control"
              v-model="customer.phone"
              placeholder="000000000">
          </div>
        </div>
        <ValidateMessage :error="validateErrors.phone_prefix" />
        <ValidateMessage :error="validateErrors.phone" />
      </div>
      
      <hr class="my-4">

      <div class="row">
        <div class="col-9">
          <div class="form-group">
            <label>Endereço *</label>
            <input
              type="text"
              class="form-control"
              v-model="customer.address">
            <ValidateMessage :error="validateErrors.address" />
          </div>
        </div>
        <div class="col-3">
          <div class="form-group">
            <label>Número *</label>
            <input
              type="text"
              class="form-control"
              v-model="customer.address_number">
            <ValidateMessage :error="validateErrors.address_number" />
          </div>
        </div>
      </div>

      <div class="form-group">
        <label>Complemento</label>
        <input
          type="text"
          class="form-control"
          v-model="customer.address_complement">
        <ValidateMessage :error="validateErrors.address_complement" />
      </div>

      <div class="form-group">
        <label>Estado *</label>
        <input
          type="text"
          class="form-control"
          v-model="customer.region">
        <ValidateMessage :error="validateErrors.region" />
      </div>

      <div class="form-group">
        <label>Cidade *</label>
        <input
          type="text"
          class="form-control"
          v-model="customer.city">
        <ValidateMessage :error="validateErrors.city" />
      </div>

      <div class="form-group">
        <label>Bairro *</label>
        <input
          type="text"
          class="form-control"
          v-model="customer.neighborhood">
        <ValidateMessage :error="validateErrors.neighborhood" />
      </div>

      <div class="form-group">
        <label>CEP *</label>
        <input
          type="text"
          class="form-control"
          v-model="customer.zipcode"
          placeholder="00000-000">
        <ValidateMessage :error="validateErrors.zipcode" />
      </div>
      <div
        :class="{'box-loading': loading}">
        <button
          class="btn btn-primary"
          @click="save">
          {{ isSteps ? $t('Avançar') : $t('Save') }}
          </button>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'BillingDetails',
  props: {
    isSteps: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      creating: true,
      loading: true,
      customer: {},
      newCustomer: false,
      validateErrors: {}
    }
  },
  computed: {
    billingResume () {
      return this.$store.getters.getBillingResume
    },
    hasCustomer () {
      return this.billingResume.has_customer
    }
  },
  created () {
    if (this.hasCustomer) {
      this.$store.dispatch('getBillingCustomer').then(res => {
        this.customer = res
      }).finally(() => {
        this.creating = this.loading = false
      })
    } else {
      this.creating = this.loading = false
    }
  },
  methods: {
    save () {
      this.loading = true
      const data = {
        name: this.customer.name,
        register_number: this.customer.register_number,
        country: this.customer.country,
        region: this.customer.region,
        city: this.customer.city,
        neighborhood: this.customer.neighborhood,
        address: this.customer.address,
        address_number: this.customer.address_number,
        address_complement: this.customer.address_complement,
        zipcode: this.customer.zipcode,
        email: this.customer.email,
        phone: this.customer.phone,
        phone_prefix: this.customer.phone_prefix
      }

      if (this.hasCustomer) {
        return this.update(data)
      } else {
        return this.create(data)
      }
    },
    create (data) {
      this.$store.dispatch('createBillingCustomer', data).then(res => {
        this.redirect()
      }).catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    update (data) {
      this.$store.dispatch('updateBillingCustomer', data).then(res => {
        this.redirect()
      }).catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    redirect () {
      if (this.isSteps) {
        this.$router.push('/billing/steps/payment')
      } else {
        this.$router.push('/billing')
      }
    },
    cancel () {
      this.$router.push('/billing')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Billing/BillingDetails.vue